import { render, staticRenderFns } from "./OtherIncomeEdit.vue?vue&type=template&id=101d7f3c"
import script from "./OtherIncomeEdit.vue?vue&type=script&lang=js"
export * from "./OtherIncomeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports